import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { IconButton } from '@calendly/ui/components/icon-button';
import { CloseIcon } from '@calendly/ui/components/icons';
import { Modal } from '@calendly/ui/components/modal';
import { Header, Title, Body, Footer } from '@calendly/ui/components/popup';
import { Sheet } from '@calendly/ui/components/sheet';
import { BodyText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { subscriptionPlanSelector } from 'features/billing/selectors';
import { TRACKING_EVENT_NAMES, useTrack, useTrackCheckoutFlowStarted } from 'hooks/analytics_events';
import headerImage from 'images/billing/mvplan_header.svg';
const imageCss = "i1iwkfzr";
const Image = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'img';
  return <Component ref={ref} {...restProps} className={classNames(imageCss, props.className)} />;
});
const styledSheetIsTabletUpCss = "su42fi5";
const styledSheetIsPhoneCss = "spf89bg";
const styledSheetCss = "s1cn1guk";
const StyledSheet = forwardRef((props, ref) => {
  const isPhone = useDeviceType('isPhone');
  const isTabletUp = useDeviceType('isTabletUp');
  return <Sheet ref={ref} {...props} className={classNames(styledSheetCss, {
    [styledSheetIsTabletUpCss]: isTabletUp,
    [styledSheetIsPhoneCss]: isPhone
  }, props.className)} />;
});
const containerCss = "cgb60td";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const bodyWrapperIsTabletUpCss = "b2zys3q";
const bodyWrapperCss = "b1utmtdo";
const BodyWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isTabletUp = useDeviceType('isTabletUp');
  return <Component ref={ref} {...restProps} className={classNames(bodyWrapperCss, {
    [bodyWrapperIsTabletUpCss]: isTabletUp
  }, props.className)} />;
});
const HeaderContent = ({
  onClose
}) => <Header>
    <Container>
      <Title>
        {I18n.t('publisher.billing.no_seats_remaining.title')}
      </Title>
      <IconButton size="small" title={I18n.t('publisher.action.close')} onClick={onClose}>
        <CloseIcon size="large" />
      </IconButton>
    </Container>
  </Header>;
const FooterContent = ({
  onClick
}) => <Footer>
    <Button as="a" href="/app/admin/billing?fk=oiseats" onClick={onClick}>
      {I18n.t('publisher.billing.action.add_seats')}
    </Button>
  </Footer>;
export const NoSeatsRemainingModal = ({
  isOpen,
  onClose,
  totalSeats
}) => {
  const track = useTrack();
  const trackCheckoutFlowStarted = useTrackCheckoutFlowStarted();
  const externalPlanId = useSelector(subscriptionPlanSelector);
  const handleClose = () => {
    onClose();
    track({
      name: TRACKING_EVENT_NAMES.MODAL_INTERACTION,
      properties: {
        modal_name: 'invite_flow_add_seats',
        action: 'closing',
        location: 'add_seats_paywall'
      }
    });
  };
  const onAddSeats = () => {
    // FIXME: should checkoutFlowLocation be "add_seats_paywall"
    trackCheckoutFlowStarted({
      checkoutPlanName: externalPlanId,
      checkoutPlanBillingTerm: externalPlanId?.includes('yearly') ? 'yearly' : 'monthly',
      checkoutFlowLocation: 'organization_invitation'
    });
  };
  return <Modal isOpen={isOpen}>
      <StyledSheet data-component="no-seats-remaining-modal">
        <Image src={headerImage} alt="" />
        <HeaderContent onClose={handleClose} />
        <Body>
          <BodyWrapper>
            <BodyText>
              {I18n.t('publisher.billing.no_seats_remaining.body', {
              seat_count: totalSeats
            })}
            </BodyText>
          </BodyWrapper>
        </Body>
        <FooterContent onClick={onAddSeats} />
      </StyledSheet>
    </Modal>;
};

require("./no_seats_remaining_modal.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./no_seats_remaining_modal.js");